/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_LabelInputs */



/**
* | output |
* | --- |
* | "HLS Manifest URL" |
*
* @param {Media_Import_Hls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_label = /** @type {((inputs?: Media_Import_Hls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du manifeste HLS")
	if (locale === "de") return /** @type {LocalizedString} */ ("HLS-Manifest-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL manifesto HLS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL манифеста HLS")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del manifiesto HLS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("HLS清单URL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("HLSマニフェストURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("HLS मैनिफेस्ट URL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do manifesto HLS")
	return /** @type {LocalizedString} */ ("HLS Manifest URL")
});